<script setup lang="ts">
import { useSelectReason } from '../../../model/additional-info/billing/info-downgrade-subscription/select-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectReason from './info-downgrade-subscription/SelectReason.vue'

defineOptions({
  name: 'InfoDowngradeSubscription',
})

const { isRequired } = useSelectReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Reason"
      :required="isRequired"
    >
      <SelectReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
